import {useEffect, useState, useCallback} from "react";
import {ChatModel} from "@/app/api/chat";
import {useNavigate} from "react-router-dom";
import {ChatRequests} from "@/app/api/chat/requests";
import {SearchParamsKey, useUrlParams} from "@/app/utils/use_search_params";
import {MessagesRequests} from "@/app/api/messages/requests";
import {MessageModel} from "@/app/api/messages";

export interface ChatState {
  hasError?: string;
  message: string;
  toggleShowAddMember: boolean
}

const useChat = () => {

  const [state, setState] = useState<ChatState>({
    hasError: undefined,
    message: "",
    toggleShowAddMember: false
  });

  const updateState = useCallback((updates: Partial<ChatState>) => {
    setState((prev) => ({...prev, ...updates}));
  }, []);

  const updateMessage = useCallback((message: string) => {
    updateState({message});
  }, [updateState]);

  const toggleShowAddMember = useCallback(() => {
    updateState({toggleShowAddMember: !state.toggleShowAddMember});
  }, [state.toggleShowAddMember, updateState]);

  return {
    message: state.message,
    showAddMember: state.toggleShowAddMember,
    updateMessage,
    toggleShowAddMember
  };
};

export default useChat;